import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ParkingPageRoutingModule } from './parking-routing.module';

import { ParkingPage } from './parking.page';

import { AgmCoreModule } from '@agm/core';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ParkingPageRoutingModule,
    TranslateModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyAP2jXShaPmZ1g0x4DNoxq2kvw2KnUYxYU"
    })
  ],
  
  declarations: [ParkingPage]
})
export class ParkingPageModule {}
